import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';



var url = window.location.hostname;
var port = window.location.port;
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      ShowpopupLoader: false,
      showValidatedOption: false,
      modalNew: false,
      FailedModal: false,
      invoice: "",
      prod_id_state : false,
      inboundData: [],
      EditModal: false,
      loader1: false,
      disable_asn_button: true,
      assignLoader: false,
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
      showFetchDispatchData: true,
      failed_message: "",
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
    };
  }

 

  toggleOKSuccess= () =>{
   window.location.reload();
  }

  toggleNew= () =>{
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }


  toggle = () =>{
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle= () =>{
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }


  toggleFailed = () =>{
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

 

  componentWillMount() {
    var Location = this.getCookie("selectedLocation");
    this.setState(
      {
        selectedLocation: Location,
        
      },
      () => {
        
        this.getInboundList();
        
      }
    );

  }



  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

 

  onInboundChange = (e) => {
    const value = e.target.value;
    this.setState({
      inbound: value,
      
    });
  };

   
 

   

ConfirmAssignData() {
    const payload = {
        po_number: this.state.po_number_data,
    };
    addAnalytics('PO Short Close', 'Clicked Short Close', payload);

    API.post('/receiving/poShortClose/', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);

      if(data.status === true){
        this.setState({
          success_message: data.reason
        })
        this.toggleNew();
      }else{
        this.setState({
          failed_message: data.reason
        })
        this.Failedtoggle();
      }
  
      //this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
}
   



  getInboundList = () => {
    
      const payload = {
        location: this.state.selectedLocation,
    };

    API.post('/receiving/fetchInboundDeliveryList/', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);
  
      this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
  }

 
   



  assembleDispatchData = (dispatchData) => {
    console.log(dispatchData, "dispatchData");
    let DispatchData = dispatchData.map((post, index) => {
     

      return {
        sequence_no : post.po_line_no,
        brand: post.brand,
        prod_code: post.SKU7_code,
        product_desc: post.product__lb_sku_product_name,
        mrp: post.mrp,
        batch: post.batch, 
        pkd: post.pkd,
        receiving_config: post.receiving_config,
        qty: post.qty,
        
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };




  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      location: this.state.selectedLocation1,
      idl_number: this.state.inbound,
  };
  addAnalytics('PO Short Close', 'Search Inbound Del.', payload);

API.post('/receiving/fetchInboundDeliveryItem/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          po_number_data: data.data[0].po_number,
        });

        
        
     

        this.setState({
         
          arr_data1: data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };






  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modalNew , Failedmodal} = this.state;

    const dispatchData = {
      columns: [
       
        {
          label : "Sequence No",
          field : "sequence_no",
          width : 130,
        },

        {
          label: "Brand",

          field: "brand",
          width: 130,
        },
        
       
        {
          label: "Prod Code",

          field: "prod_code",
          width: 120,
        },
        {
          label: "Prod Desc",

          field: "product_desc",
          width: 140,
        },
        {
          label: "Mrp",

          field: "mrp",
          width: 90,
        },


        {
          label: "Batch",

          field: "batch",
          width: 110,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 90,
        },

        {
          label: "Receiving Config",

          field: "receiving_config",
          width: 130,
        },

        {
          label: "QTY",

          field: "qty",
          width: 100,
        },

        


      ],

      rows: this.state.tableRowsMap,
    };



    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 12 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>
             
               <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <select
                    className="form-control"
                    style={{ fontSize: 13, }}
                    onChange={this.onInboundChange}
                  >
                    <option value="">Select Inbound Del No.</option>
                    {
                      this.state.inboundData.length > 0 &&
                      this.state.inboundData.map((inboundData) => {
                        return (
                          <option value={inboundData.inbound_delivery_number}> {inboundData.inbound_delivery_number}</option>
                        );
                      })}
                  </select>

                   {/*<input type = "text" className="form-control group_text1" placeholder= "Inbound Delivery Number" onChange={this.onInboundChange}/>*/}
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <div>
            <CardBody style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0 }}>


              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

              <div style={{width: '100%', float: 'left', marginTop: 12}}>
              
                    <div style={{width: '100%', float: 'left', marginTop: 2}}>
                  
               

                <Button  style={{marginBottom: 20, marginTop:8, marginLeft: 8, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.ConfirmAssignData()}>{this.state.asnLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}Short Close</Button></div>
                    </div>
                    <div style={{marginBottom: 8}}>
                    <span style={{paddingBottom: 8}}><strong>PO Number: {this.state.po_number_data}</strong></span>
                    </div>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="700px"
                  searching={false}
                  displayEntries={false}
                   paging= {false}
                  striped
                  bordered
                  data={dispatchData}
                />


              </div>

                      
            </CardBody>

            </div>
          )}
        </Card>

         <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKSuccess}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

       

      

          <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

       
        
       
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
